<template>
    <div class="clientDetail">
      <!--navBar-->
      <navBar></navBar>
      <!--中间内容部分-->
      <div class="main">
        <div class="mainContainer">
          <div class="nav_detail">
            <span class="nav_back" @click="goBack">案例中心</span> > <span>新网银行</span>
          </div>
          <div class="flex_between">
            <div class="item_left">
              <div class="icon"><i></i></div>
              <p class="title">新网银行</p>
              <div class="intro">
                <div>客户简介</div>
                <p>四川新网银行是全国三家互联网银行之一，于2016年12月28日正式开业。新网银行注册资本30亿元，由新希望集团、小米、红旗连锁等股东发起设立，是银监会批准成立的全国第七家民营银行，也是四川省首家民营银行。</p>
              </div>
              <div class="products">
                <div>使用产品</div>
                <p @click="goProduct('/product2')">渗透测试</p>
                <p @click="goProduct('/product1')">漏洞扫描</p>
                <p @click="goProduct('/product3')">专家服务</p>
              </div>
            </div>
            <div class="item_right">
              <div class="title">
                <i></i>业务背景
              </div>
              <p>新网银行作为全国三家互联网之一，因此网络安全对于自身的业务显得至关重要，自身的软硬件系统漏洞，有可能会让黑客有机可乘，为了避免造成相关的网络安全事故和经济及社会损失，由牛盾安全专家对其网络和系统进行安全渗透测试等安全服务，提高安全保障。</p>
              <div class="item_img"><img src="../../assets/img/clientDetail/client3_big.jpg" alt=""></div>
              <div class="title">
                <i></i>解决方案
              </div>
              <p>先黑客一步发现风险：通过模拟真实的黑客攻击手段，从海量蜜罐系统中提取数据，筛选出无数可穿墙的程序代码，最后再编译到牛盾漏洞扫描规则库中，真正做到先黑客一步发现问题，助力政府、企业和个人打造安全、稳定、高效的业务应用环境。模拟黑客攻击对业务系统进行安全性测试，比黑客更早发现可导致企业数据泄露、资产受损、数据被篡改等漏洞，并协助企业进行修复。</p>
              <div class="title">
                <i></i>方案价值
              </div>
              <p>为用户定制完备的风险规避方案，保障测试业务中业务不受影响。在客户授权的情况下，对客户主机、网络设备、应用系统、操作系统、数据库等进行全面的基线加固和组件升级，针对系统的安全隐患等提供安全加固方案，整体上提高系统的安全防御能力。   </p>
            </div>
          </div>
        </div>
      </div>
      <!--footerBar-->
      <div class="gw_homefooterBox">
        <footerBar></footerBar>
      </div>
    </div>
</template>

<script>
    import navBar from '../../components/Navbar';
    import footerBar from '../../components/footerbar'
    export default {
      components:{
        navBar,footerBar
      },
      methods:{
        goBack(){
          this.$router.push('/client');
        },
        goProduct(url){
          this.$router.push(url);
          window.scrollTo({top:0});
        }
      }
    }
</script>

<style scoped lang="scss">
  .clientDetail{
    .item_left{
      .icon{
        i{
          width:174px;
          height:26px;
          background:url("../../assets/img/clientDetail/client3_icon.png") no-repeat center;
          background-size:100% 100%;
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/views/client/client3.vue